import React from "react";

interface RightChevronProps {
  width?: number;
  height?: number;
  color?: string;
}

const RightChevron = ({
  width = 14,
  height = 14,
  color = "#1F1F1F",
}: RightChevronProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 3.5L8.75 7L5.25 10.5"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RightChevron;
